import { Navigate, useParams } from "react-router-dom";

export default function NearMeLocalityRedirect({ basePath }) {
  const { city } = useParams();
  return <Navigate to={`${basePath}/${city}`} replace />;
}
